module.exports = __webpack_public_path__ + "static/to-kill-a-mockingbird-12a0944f8a78a6d7a2f40d35220d1e2a.jpg";